<!-- User Fia Pin Modal -->
<div
  style="overflow-y: auto"
  mdbModal
  #userFiaPinModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  (close)="onClosed($event)"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ userProfile.fullName }} - New FIA Pin</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!busy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showError && manuallyEnterPinInfo" class="alert alert-warning text-center font-weight-bold" role="alert">
              <p>{{ errorMsg }}</p>
              <p>Please manually enter the pin information below.</p>
            </div>
            <div *ngIf="showError && !manuallyEnterPinInfo" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <!--Main Body-->
          <!-- FIA Amount -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="newPin.pinAmount"
              mdbInput
              mdbValidate
              name="pinAmount"
              type="number"
              id="pinAmount"
              class="form-control"
              #pinAmount="ngModel"
              required
            />
            <label for="pinAmount">Pin Amount</label>
            <mdb-error *ngIf="pinAmount.invalid && (pinAmount.dirty || pinAmount.touched)">Pin Amount is required </mdb-error>
            <mdb-success *ngIf="pinAmount.valid && (pinAmount.dirty || pinAmount.touched)"></mdb-success>
          </div>
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">Fia Document</p>
          </div>
          <p class="text-left">This is where you can upload a FIA pin document for the selected user</p>
          <!--Main Body-->
          <div class="selection-item-full">
            <div class="dropzone" filedropzone="">
              <div class="text-wrapper">
                <i class="fas fa-upload"></i>
                <p class="hidden-sm-down">
                  <a class="is-link"><strong>Browse</strong></a> to select files from your computer
                </p>
                <p class="hidden-sm-up">Click/tap to add your files or drag and drop them here</p>
              </div>
              <input
                class="hidden w-100 h-100"
                type="file"
                multiple="multiple"
                #file
                (change)="onFileChange($event)"
                name="fileUploadArea"
              />
            </div>
          </div>

          <div class="d-block col-12">
            <p class="font-weight-bold mb-1" *ngIf="pinDocument">New Pin Document</p>
          </div>
          <table class="col-12" mdbTable hover="true" small="true" *ngIf="pinDocument" responsive="true">
            <thead>
              <tr>
                <th scope="col" class="col-4">File Name</th>
                <th scope="col" class="col-6">Type</th>
                <th scope="col" class="col-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol>
                <td class="align-middle">{{ pinDocument.fileName }}</td>
                <td class="align-middle">{{ pinDocument.fileType }}</td>
                <td class="align-middle">
                  <a class="border dropdown-item text-center my-1" size="sm" (click)="removeFile(pinDocument.fileName)" mdbWavesEffect
                    >Remove</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="manuallyEnterPinInfo" class="card-header">
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">Manually Enter Data</p>
          </div>
          <div class="row px-4">
            <div class="md-form col-6">
              <input
                [(ngModel)]="newPin.pin"
                mdbInput
                mdbValidate
                name="pin"
                type="text"
                id="pin"
                class="form-control"
                #pin="ngModel"
                required
                minlength="10"
                maxlength="10"
              />
              <label for="pin">Pin</label>
              <mdb-error *ngIf="pin.errors?.required && (pin.dirty || pin.touched)">Pin is required</mdb-error>
              <mdb-error *ngIf="(pin.errors?.minlength || pin.errors?.maxlength) && (pin.dirty || pin.touched)"
                >Pin must be 10 characters long</mdb-error
              >
              <mdb-success *ngIf="pin.valid && (pin.dirty || pin.touched)"></mdb-success>
            </div>

            <div class="md-form col-6">
              <input
                [(ngModel)]="newPin.pinIssueDate"
                mdbInput
                mdbValidate
                name="pinIssueDate"
                type="date"
                id="pinIssueDate"
                class="form-control"
                #pinIssueDate="ngModel"
                required
              />
              <label for="pinIssueDate">Pin Issue Date</label>
              <mdb-error *ngIf="pinIssueDate.invalid && (pinIssueDate.dirty || pinIssueDate.touched)">Pin Issue Date is required</mdb-error>
              <mdb-success *ngIf="pinIssueDate.valid && (pinIssueDate.dirty || pinIssueDate.touched)"></mdb-success>
            </div>
          </div>

          <div class="row px-4">
            <div class="md-form col-12">
              <input
                [(ngModel)]="manualRequestReferenceNumber"
                mdbInput
                mdbValidate
                name="reference"
                type="text"
                id="reference"
                class="form-control"
                #reference="ngModel"
                required
                minlength="25"
                maxlength="25"
              />
              <label for="reference">Request Reference Number</label>
              <mdb-error *ngIf="reference.errors?.required && (reference.dirty || reference.touched)"
                >Request Reference Number is required</mdb-error
              >
              <mdb-error *ngIf="(reference.errors?.minlength || reference.errors?.maxlength) && (reference.dirty || reference.touched)"
                >Request Reference Number must be 25 characters long</mdb-error
              >
              <mdb-success *ngIf="reference.valid && (reference.dirty || reference.touched)"></mdb-success>
            </div>
          </div>
        </div>
        <!--Loading-->
        <div *ngIf="busy" class="col-12 text-center">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <!--Save btn-->
      <div class="modal-footer justify-content-right">
        <button
          *ngIf="!busy && newPin.pinAmount > 0 && pinDocument && canCreatePin()"
          type="button"
          mdbBtn
          color="trakly-action"
          class="relative waves-light"
          (click)="fiaPinCreateClicked()"
        >
          Create
        </button>
        <button *ngIf="!busy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">Close</button>
      </div>
    </div>
  </div>
</div>
